import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import MainLayout from "../components/MainLayout";
import Home from "../pages/Home";
import ProductInnerPage from "../pages/ProductInnerPage";
import ProductsOffered from "../pages/ProductsOffered";

import Login from "../admin/Pages/Login";
import Services from "../admin/Pages/Services";
import AdminLayout from "../admin/Components/AdminLayout";
import Enquiries from "../admin/Pages/Enquiries";
import Announcement from "../admin/Pages/Announcement";

const Allroutes = () => {
    return (
        <Router basename={'/'} >
            <Routes>
                <Route exact path="/" element={<MainLayout><Home /></MainLayout>} />
                <Route exact path="/products/:title/:id" element={<MainLayout><ProductInnerPage /></MainLayout>} />
                <Route exact path="/all-products-offered" element={<MainLayout><ProductsOffered /></MainLayout>} />

                <Route exact path="/admin" element={<Login />} />
                <Route exact path="/admin/login" element={<Login />} />
                <Route exact path="/admin/offered-products" element={<AdminLayout><Services /></AdminLayout>} />
                <Route exact path="/admin/enquiries" element={<AdminLayout><Enquiries /></AdminLayout>} />
                <Route exact path="/admin/announcement" element={<AdminLayout><Announcement /></AdminLayout>} />
            </Routes>
        </Router>
    )
}

export default Allroutes;